<div class="language-selector">
  <button class="language-selector-button" 
          [matMenuTriggerFor]="languageMenu"
          mat-button>
    <span class="fi fi-{{currentLanguage.code}} language-selector-button-flag"></span> &nbsp;
    <span class="language-selector-button-name">{{currentLanguage.code | uppercase}}</span>
    <mat-icon class="language-selector-button-icon">arrow_drop_down</mat-icon>
  </button>

  <mat-menu #languageMenu="matMenu" class="language-menu">
    @for (lang of languages; track lang.code) {
      <button mat-menu-item
              class="language-selector-menu-item"
              [class.active]="currentLanguage.code === lang.code"
              (click)="selectLanguage(lang)">
        <div class="language-item-row">
          <span class="fi fi-{{lang.code}} language-selector-menu-item-flag"></span> &nbsp;
          <span class="language-name">{{lang.name}}</span>
        </div>
      </button>
    }
  </mat-menu>
</div>